import { supabase } from '../supabase';

/**
 * Fetches all schedule entries (events) for a venue, past and future,
 * for use in overview pages (list/calendar/grid) rather than "today only".
 * @param {string|number} venueId - The venue ID to fetch events for
 * @returns {Promise<Array>} - A promise that resolves to an array of events
 */
export const fetchEvents = async (venueId) => {
  if (!venueId) return [];

  const { data, error } = await supabase
    .from('schedule')
    .select('*')
    .eq('venue_id', venueId)
    .order('start_time', { ascending: true });

  if (error) {
    console.error('Error fetching events:', error);
    return [];
  }

  return data || [];
};
